var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiempoReloj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2854 7.35276C17.8722 7.35276 18.3479 7.82846 18.3479 8.41526V16.5602L22.5842 20.7965C22.9991 21.2114 22.9991 21.8841 22.5842 22.2991C22.1693 22.714 21.4965 22.714 21.0816 22.2991L16.5341 17.7516C16.3349 17.5523 16.2229 17.2821 16.2229 17.0003V8.41526C16.2229 7.82846 16.6986 7.35276 17.2854 7.35276Z",
    fill: "#3677DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2854 4.74609C10.5176 4.74609 5.03125 10.2325 5.03125 17.0003C5.03125 23.768 10.5176 29.2544 17.2854 29.2544C24.0532 29.2544 29.5396 23.768 29.5396 17.0003C29.5396 10.2325 24.0532 4.74609 17.2854 4.74609ZM2.90625 17.0003C2.90625 9.05887 9.34402 2.62109 17.2854 2.62109C25.2268 2.62109 31.6646 9.05887 31.6646 17.0003C31.6646 24.9417 25.2268 31.3794 17.2854 31.3794C9.34402 31.3794 2.90625 24.9417 2.90625 17.0003Z",
    fill: "#3677DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiempoReloj);
export default __webpack_public_path__ + "static/media/TIEMPO_RELOJ.1f9e6c6e268ff1dd02c98f145504b896.svg";
export { ForwardRef as ReactComponent };